import { shouldDisplayMainsInServings } from 'src/pages/consumer/meal-plans/utils/shouldDisplayMainsInServings';
import { useCartStoreSelectors } from 'src/ztore/cart-store';
import { useIsUserInFlexServings } from './useIsUserInFlexServings';

/**
 * Whether this user's meal-plan dish-selection surfaces should count mains by the serving.
 *
 * Reads `numServings` from the cart store — the same source every flex mechanic already uses — so
 * the framing and the mechanics can never disagree. `setMealPlanConfig` populates it in the same
 * `useOnMount` that gates the menu query, so no dish card renders before it is correct. See
 * `shouldDisplayMainsInServings` for why one-serving flex plans count in mains.
 */
export const useShouldDisplayMainsInServings = (): boolean => {
  const isFlexServings = useIsUserInFlexServings();
  const numServings = useCartStoreSelectors.use.numServings();

  return shouldDisplayMainsInServings({ isFlexServings, numServings });
};
